import { ApiCacheTags, baseApiService } from '@qapline/api';
import { config } from 'config';
import { cashflowSourceTags } from 'core/cashflow/api/tags';

import {
    earlyPayDashboardSchema,
    earlyPayOverviewSchema,
    earlyPaySettingsSchema,
    TEarlyPayDashboard,
    TEarlyPayOverview,
    TEarlyPaySettings,
    TGetEarlyPayOverviewRequest,
} from '../types';

const earlyPayApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        getEarlyPayOverview: builder.query<TEarlyPayOverview, TGetEarlyPayOverviewRequest>({
            query: ({ commissionId, discount }) => ({
                url: config.api.endpoints.earlyPay.overview(commissionId),
                method: 'GET',
                params: discount === undefined ? undefined : { discount },
            }),
            providesTags: (_response, error, { commissionId }) =>
                error ? [] : [{ type: ApiCacheTags.earlyPay.overview, id: commissionId }, ...cashflowSourceTags],
            transformResponse: (response) => earlyPayOverviewSchema.parse(response),
        }),
        getEarlyPaySettings: builder.query<TEarlyPaySettings, void>({
            query: () => ({
                url: config.api.endpoints.earlyPay.settings,
                method: 'GET',
            }),
            providesTags: [ApiCacheTags.earlyPay.settings],
            transformResponse: (response) => earlyPaySettingsSchema.parse(response),
        }),
        getEarlyPayDashboard: builder.query<TEarlyPayDashboard, void>({
            query: () => ({
                url: config.api.endpoints.earlyPay.dashboard,
                method: 'GET',
            }),
            providesTags: [ApiCacheTags.earlyPay.dashboard, ...cashflowSourceTags],
            transformResponse: (response) => earlyPayDashboardSchema.parse(response),
        }),
        updateEarlyPaySettings: builder.mutation<TEarlyPaySettings, TEarlyPaySettings>({
            query: (body) => ({
                url: config.api.endpoints.earlyPay.settings,
                method: 'PUT',
                body,
            }),
            invalidatesTags: [
                ApiCacheTags.earlyPay.settings,
                ApiCacheTags.earlyPay.overview,
                ApiCacheTags.earlyPay.dashboard,
                ApiCacheTags.cashflow.dashboard,
            ],
            transformResponse: (response) => earlyPaySettingsSchema.parse(response),
        }),
    }),
});

export const {
    useGetEarlyPayDashboardQuery,
    useGetEarlyPayOverviewQuery,
    useGetEarlyPaySettingsQuery,
    useUpdateEarlyPaySettingsMutation,
} = earlyPayApi;
